import every from 'lodash/every';
import pick from 'lodash/pick';
import values from 'lodash/values';

import { permissionsFilters } from '~/queries/helpers';

export type TPermissions = { [key: string]: {} | TPermissions } | {};

export default function checkPermissions(
  permissions: TPermissions, permissionsKeys: string[],
): boolean {
  // What we're doing here is:
  // - grabbing an object with just the SSN and DOB permissions key-value pairs
  //   from permissionsFilters with pick(),
  const permissionsPairs: TPermissions = pick(
    permissionsFilters, permissionsKeys,
  );
  // - grabbing those permissions strings with values()
  // FIXME: This will not return an array of strings, this will return an array of TPermissions, which are either empty objects, or nested empty objects
  // @ts-expect-error -- The type returned from values is incompatible
  const permissionsStrings: string[] = values(permissionsPairs);
  // - mapping over each string and checking they exist in the permissions
  // - and calling every() on that resulting array of Booleans which will tell
  //   us if the user has every permission needed to see the panel
  const hasAllPermissions: boolean = every(
    permissionsStrings.map(permission => (
      {}.hasOwnProperty.call(permissions, permission)
    )),
  );

  return hasAllPermissions;
}
